// @flow @format
export {default} from './Modal';



// WEBPACK FOOTER //
// ./src/components/Modal/index.js